<h3 mat-dialog-title>DP Sensor</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Machinery Name</mat-label>
            <input matInput type="text" name="machinery_name" [(ngModel)]="trailDpSensor.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Records checked?</mat-label>
            <mat-select name="records_checked" [(ngModel)]="selectedState">
                @for (state of checkedStates; track state) {
                <mat-option [value]="state">{{state.expression}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remark</mat-label>
            <textarea matInput type="text" name="remark" [(ngModel)]="trailDpSensor.remark"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailDpSensor" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>
